import { db } from '../config/firebase';
import { 
  collection, 
  getDocs, 
  addDoc, 
  query, 
  where, 
  Timestamp 
} from 'firebase/firestore';

const tournamentNamesRef = collection(db, 'tournamentNames');

export const tournamentNameService = {
  // 大会名一覧の取得
  async getAllTournamentNames() {
    try {
      const snapshot = await getDocs(tournamentNamesRef);
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('大会名一覧の取得に失敗:', error);
      throw error;
    }
  },

  // 大会名の存在確認
  async checkTournamentNameExists(name) {
    try {
      const q = query(tournamentNamesRef, where('name', '==', name));
      const snapshot = await getDocs(q);
      return !snapshot.empty;
    } catch (error) {
      console.error('大会名の確認に失敗:', error);
      throw error;
    }
  },

  // 大会名の登録
  async createTournamentName(name) {
    try {
      const exists = await this.checkTournamentNameExists(name);
      if (exists) {
        throw new Error('この大会名は既に登録されています');
      }

      const docRef = await addDoc(tournamentNamesRef, {
        name,
        createdAt: Timestamp.now()
      });
      return docRef.id;
    } catch (error) {
      console.error('大会名の登録に失敗:', error);
      throw error;
    }
  }
};
